import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { catchError, map, Observable, of, tap } from 'rxjs';
import { EventResponse } from '../../details/models/details.model';
import { CompanyInsightApiResponse, CompanyJobApiResponse } from '../models/company-insight.model';
import { formatLocation } from '../utils/company-insight.utils';
import { environment } from '../../../../environments/environment';

const API_BASE = 'https://recruiter-dashboard-api-prod-spqpfdqcqa-as.a.run.app';

@Injectable({ providedIn: 'root' })
export class CompanyInsightService {

    private companyInsightJobCache = new Map<string, CompanyJobApiResponse[]>();
    private readonly http = inject(HttpClient);


    private savedJobsUrl = 'https://job-subsystem-verify-api-prod.bdjobs.com/api/v1/Jobs/GetShortlistedJobId'

    getInsight( companyId: string, isCompanyDetails: boolean, UserId?: string) :
    Observable<CompanyInsightApiResponse> {

        let params = new HttpParams()
            .set('CompanyId', companyId)
            .set('isDetails', String(isCompanyDetails));

        if (UserId !== null && UserId !== undefined) {
            params = params.set('UserId', UserId);
        }

        return this.http.get<CompanyInsightApiResponse>(
            `${API_BASE}/api/GetCompanyInsight`,
            { params }
        );
    }

    getCompanyJobs(companyId: string, companyName: string, toggleJobs: boolean): Observable<CompanyJobApiResponse[]> {
        const cachedKey = `${companyId}-${companyName}-${toggleJobs}`;
        const cachedJobs = this.companyInsightJobCache.get(cachedKey);
        if(cachedJobs){
            return of(cachedJobs);
        }

           return this.http
                .get<CompanyJobApiResponse[]>(
                    environment.companyJobListApiUrl,
                    {
                        params: new HttpParams()
                            .set('companyId', companyId)
                            .set('companyName', companyName)
                            .set('ToggleJobs', String(toggleJobs)),
                    }
                )
                .pipe(
                    map(jobs =>
                        jobs.map(job => ({
                            ...job,
                            location: formatLocation(job.location ?? ''),
                        }))
                    ),
                    tap(jobs => this.companyInsightJobCache.set(cachedKey, jobs)),
                    catchError(() => {
                       this.companyInsightJobCache.delete(cachedKey); 
                       return of([])
                    })
                )
       
    }

  

    getSavedJobs(userId:string): Observable<EventResponse<number[]>> {
        return this.http.get<EventResponse<number[]>>(
            `${this.savedJobsUrl}?JobSeekerId=${userId}`
        );
    }
}
